import React, {useState} from 'react';

import {LoadingIndicator} from "../loading/loading-indicator";
import {IntersectionObserver} from "../intersection-observer/intersection-observer";
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {throttle} from "../../../infrastructure/throttle/throttle";

export class InfiniteScrollComponentProps extends BaseProps {
  hasMore: Boolean;
  loadMore: Function;
  Loader: React.Component;
  intersectionObserverMargin: String;
  intersectionObserverThreshold: Number;
}

export const InfiniteScroll = ({
                                 Loader,
                                 loadMore,
                                 hasMore,
                                 children,
                                 intersectionObserverMargin,
                                 intersectionObserverThreshold
                               }: InfiniteScrollComponentProps) => {

  const [isLoadingMore, setIsLoadingMore] = useState(true);
  const LoaderComponent = Loader || LoadingIndicator;

  const intersectDelay: Number = 300

  const onIntersectThrottle = throttle(() => onIntersect(), intersectDelay);

  const onIntersect = async () => {
    setIsLoadingMore(false);
    await loadMore();
    setIsLoadingMore(true)
  }

  return (
    <React.Fragment>
      {
        children
      }
      {
        isLoadingMore ? (hasMore && <IntersectionObserver
          forceRender={true}
          onIntersect={() => onIntersectThrottle()}
          margin={intersectionObserverMargin}
          threshold={intersectionObserverThreshold}
        >
          <LoaderComponent/>
        </IntersectionObserver>) :
          <LoaderComponent/>
      }
    </React.Fragment>
  )
};
